/** Backend `table.type` / `collection.type` for non-Adalo DB collections */
export const COLLECTION_TABLE_TYPE = {
  API: 'api',
  SHEETBRIDGE: 'sheetbridge',
  XANO: 'xano',
} as const

/** Use in JS modules when importing only the SheetBridge table type string */
export const SHEETBRIDGE_TABLE_TYPE = COLLECTION_TABLE_TYPE.SHEETBRIDGE

export type CollectionTableType =
  typeof COLLECTION_TABLE_TYPE[keyof typeof COLLECTION_TABLE_TYPE]

/** Ordered for UI lists; use `isExternalCollectionTableType` for membership */
export const EXTERNAL_COLLECTION_TABLE_TYPES: CollectionTableType[] = [
  COLLECTION_TABLE_TYPE.XANO,
  COLLECTION_TABLE_TYPE.API,
  COLLECTION_TABLE_TYPE.SHEETBRIDGE,
]

export function isApiLikeCollectionTableType(
  type: string | undefined | null
): boolean {
  return (
    type === COLLECTION_TABLE_TYPE.API ||
    type === COLLECTION_TABLE_TYPE.SHEETBRIDGE
  )
}

export function isExternalCollectionTableType(
  type: string | undefined | null
): boolean {
  return (
    isApiLikeCollectionTableType(type) || type === COLLECTION_TABLE_TYPE.XANO
  )
}

export function isXanoCollectionTableType(
  type: string | undefined | null
): boolean {
  return type === COLLECTION_TABLE_TYPE.XANO
}
